import { type RootContainerProps } from "@client/content/types";
import { connectCustom } from "@client/lib/misc";
import { type AppState } from "@client/types";
import { init } from "./actions";
import Component, { type ActionProps, type MapProps } from "./component";
import { getIdsSelector, localStateSelector, makeBlocksStyleSelector, makeContentStyleSelector } from "./selectors";

const makeMapStateToProps = () => {
  const contentStyleSelector = makeContentStyleSelector();
  const blocksStyleSelector = makeBlocksStyleSelector();
  const idsSelector = getIdsSelector();

  return (state: AppState, props: RootContainerProps): MapProps => {
    const localState = localStateSelector(state, props);
    return {
      ...props,
      ...idsSelector(state, props),
      blocksStyle: blocksStyleSelector(state, props),
      contentStyle: contentStyleSelector(state, props),
      isEditMode: state.isEditMode,
      package: localState.package,
      tiers: localState.tiers,
      trial: localState.trial
    };
  };
};

const mapDispatchToProps =
  () =>
  (dispatch: any, props: RootContainerProps): ActionProps => ({
    init: () => dispatch(init(props))
  });

export default connectCustom(makeMapStateToProps, mapDispatchToProps)(Component);
